/* Scope behavior to connected sections, including Theme Editor/SPA remounts. */
if (!customElements.get('asif-spaces-navigation')) {
  customElements.define('asif-spaces-navigation', class extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.abort = new AbortController();
      this.dataset.ready = 'true';
      const links = [...this.querySelectorAll('.spaces-page-nav a')];
      const select = this.querySelector('select');
      const targets = links.map(link => document.querySelector(link.hash));
      const update = () => {
        const line = this.getBoundingClientRect().bottom + 160;
        let active = 0;
        let nearest = -Infinity;
        targets.forEach((target, index) => {
          const top = target?.getBoundingClientRect().top;
          if (top <= line && top > nearest) { nearest = top; active = index; }
        });
        links.forEach((link, index) => index === active ? link.setAttribute('aria-current', 'location') : link.removeAttribute('aria-current'));
        if (select && document.activeElement !== select) select.value = links[active].hash;
      };
      const queue = () => {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => { this.frame = 0; update(); });
      };
      select?.addEventListener('change', () => { location.hash = select.value; }, { signal: this.abort.signal });
      window.addEventListener('scroll', queue, { passive: true, signal: this.abort.signal });
      window.addEventListener('resize', queue, { passive: true, signal: this.abort.signal });
      update();
    }
    disconnectedCallback() { this.abort?.abort(); cancelAnimationFrame(this.frame); this.frame = 0; }
  });
}
if (!customElements.get('asif-review-copy')) {
  customElements.define('asif-review-copy', class extends HTMLElement {
    connectedCallback() {
      this.observer?.disconnect();
      const apply = () => {
        const title = this.querySelector('.asifr__head h3');
        const source = this.querySelector('.asifr__eyebrow');
        const intro = this.querySelector('.asifr__intro');
        if (title && title.textContent !== this.dataset.heading) title.textContent = this.dataset.heading;
        if (source && source.textContent !== this.dataset.source) source.textContent = this.dataset.source;
        if (intro && intro.textContent) intro.textContent = '';
      };
      this.observer = new MutationObserver(apply);
      this.observer.observe(this, { childList: true, subtree: true });
      apply();
    }
    disconnectedCallback() { this.observer?.disconnect(); }
  });
}
